export enum PrintingPatternLanguage {
    ENG = 'ENG',
    DE = 'DE'
}
